import { Provider } from '@/pages/pay';

export const sandboxProviders: Array<Provider> = [
  {
    externalId: `ob-sandbox-natwest`,
    name: `Natwest Sandbox`,
    logo: `https://fena-assets.s3.eu-west-2.amazonaws.com/banks/natwest.png`,
  },
  {
    externalId: `ob-sandbox-rbs`,
    name: `RBS Sandbox`,
    logo: `https://fena-assets.s3.eu-west-2.amazonaws.com/banks/rbs.png`,
  },
  /* {
    externalId: `ob-sandbox-revolut`,
    name: `Revolut Sandbox`,
    logo: ``,
  }, */
  // This one is not working
  // {
  //   externalId: `ob-sandbox-tsb`,
  //   name: `TSB Sandbox`,
  //   logo: `https://fena-assets.s3.eu-west-2.amazonaws.com/banks/tsb.png`,
  // },
  // {
  //   externalId: `ob-sandbox-lloyds`,
  //   name: `Lloyds Sandbox`,
  //   logo: ``,
  // },
  {
    externalId: `ob-sandbox-coutts`,
    name: `Coutts Sandbox`,
    logo: `https://fena-assets.s3.eu-west-2.amazonaws.com/banks/Coutts.png`,
  },
];

export const sandboxProviderCredentials = {
  'ob-sandbox-natwest': [
    `Bank number: 123456789012`,
    `The PIN and password numbers you need to input are written directly above the fields`,
  ],
  'ob-sandbox-rbs': [
    `Bank number: 123456789012`,
    `The PIN and password numbers you need to input are written directly above the fields`,
  ],
  // 'ob-sandbox-revolut': [`Phone: +44 7275947393`, `PIN: 0000`],
  'ob-sandbox-tsb': [
    `Username: testuser12 for payments, testuser14 for standing orders`,
    `The password, memorable information, and one time password can be anything`,
  ],
  'ob-sandbox-coutts': [`Username: 'alice' or 'bob'`, `Passcode: secret`],
};
